import { AfterViewInit, Component, TemplateRef, ViewChild } from '@angular/core';
import { CREATE_LABEL, SAVE_CHANGES_LABEL } from '@microsec/constants';
import { IPV4_PATTERN } from '@microsec/constants';
import { BaseComponent } from '@ids-components';
import { FormBuilderComponent } from '@microsec/components';
import { FormItem } from '@microsec/models';
import { AnomalyAnalyzerService } from '@ids-services';

import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { IP_RULE_TYPES } from '@ids-constants';

export const FORM_PARAMS = {
  IP: 'ip',
  ENABLED: 'enabled',
  COMMENT: 'comment',
};
@Component({
  selector: 'app-ip-whitelist-form',
  templateUrl: './ip-whitelist-form.component.html',
  styleUrls: ['./ip-whitelist-form.component.scss'],
  imports: [FormBuilderComponent],
})
export class IpWhitelistFormComponent extends BaseComponent implements AfterViewInit {
  analyzerId: any = null;

  whitelist: any = null;

  CREATE_LABEL = CREATE_LABEL;

  SAVE_CHANGES_LABEL = SAVE_CHANGES_LABEL;

  FORM_PARAMS = FORM_PARAMS;

  fields: FormItem[] = [];

  @ViewChild('fb') form!: FormBuilderComponent;

  @ViewChild('criticalityField') criticalityField!: TemplateRef<any>;

  constructor(
    public anomalyAnalyzerSrv: AnomalyAnalyzerService,
    public dialogConfig: DynamicDialogConfig,
  ) {
    super();
  }

  async ngAfterViewInit() {
    await this.prepareConfigs();
    this.analyzerId = this.dialogConfig?.data?.analyzerId;
    this.whitelist = this.dialogConfig?.data?.data;
    this.initForm();
  }

  initForm() {
    const fields: FormItem[] = [
      Object.assign(new FormItem(), {
        name: FORM_PARAMS.IP,
        label: 'IP for whitelisting',
        required: true,
        focused: true,
        fieldInfo: 'IP',
        pattern: IPV4_PATTERN,
        defaultValue: this.whitelist?.[FORM_PARAMS.IP] || '',
      } as FormItem),
      Object.assign(new FormItem(), {
        name: FORM_PARAMS.COMMENT,
        label: 'Comment',
        required: true,
        field: 'textarea',
        fieldInfo: 'Comment of the rule',
        defaultValue: this.whitelist?.[FORM_PARAMS.COMMENT] || '',
      } as FormItem),
      Object.assign(new FormItem(), {
        name: FORM_PARAMS.ENABLED,
        label: 'Enabled',
        field: 'checkbox',
        defaultValue: this.whitelist?.[FORM_PARAMS.ENABLED] || true,
      } as FormItem),
      Object.assign(new FormItem(), {
        name: 'type',
        defaultValue: IP_RULE_TYPES.WHITELIST,
        hidden: true,
      }),
    ];
    this.fields = fields;
  }

  onSubmit(closeDialog: (rs: any) => void) {
    const payload = this.form.getRawValue();
    closeDialog(payload);
  }
}
